import { ReactNode } from 'react'

interface FormBlockProps {
  title: string
  description?: string | ReactNode
  children: ReactNode
}

export const FormBlock = ({ title, description, children }: FormBlockProps) => {
  return (
    <section className="flex flex-col gap-4 rounded-xl border border-border-primary p-4 lg:flex-row lg:gap-12">
      <div className="w-full">
        <p className="mb-0.5 text-paragraph-md font-semibold text-text-secondary">{title}</p>
        <p className="w-full text-paragraph-xs text-text-tertiary lg:w-[70%]">{description}</p>
      </div>
      <div className="w-full">{children}</div>
    </section>
  )
}
